export default function InNetworkIcon({ width = 12, height = 12, ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={width} height={height} viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <circle cx='6' cy='6' r='6' fill='#4c9c49' />
      <path
        fill='#fff'
        d='M8.201 3.89 5.048 7.041 3.899 5.893a.501.501 0 0 0-.708.709l1.503 1.503a.5.5 0 0 0 .708 0L8.91 4.598a.501.501 0 0 0-.708-.709'
      />
    </svg>
  );
}
